import { Path } from 'fabric';
import SquiggleyLine from './makeSquiggleyLine';
import ShotLine from './makeShotLine';

const makePathLine = (lineType = 'line-solid', scaleFactor = 1): Path => {
  const defaultPath = 'M 0 0 Q 0 0 1 0';
  const defaultLineOptions = {
    objectCaching: false,
    selectable: false,
    hasBorders: false,
    hasControls: false,
    excludeFromExport: false,
    fill: null,
    stroke: '#fff',
    strokeWidth: Math.max(Math.round(3 * scaleFactor * 100) / 100, 1.5),
  };
  let result: Path;
  switch (lineType) {
    case 'line-squiggley': {
      result = new SquiggleyLine(defaultPath, { ...defaultLineOptions });
      break;
    }
    case 'line-shot': {
      result = new ShotLine(defaultPath, { ...defaultLineOptions });
      break;
    }
    case 'line-dotted': {
      result = new Path(defaultPath, {
        ...defaultLineOptions,
        strokeDashArray: [5, 3],
      });
      break;
    }
    case 'line-solid': {
      result = new Path(defaultPath, { ...defaultLineOptions });
      break;
    }
    default: {
      // if for some reason nothing is provided, just stick with a solid line as a default
      result = new Path(defaultPath, { ...defaultLineOptions });
    }
  }
  result.name = lineType || '';
  return result;
};

export default makePathLine;
